const Ports: number[] = [
    8080,
    8081,
    3000,
    3001
];

export default Ports;
